import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// New UI only: plays the APWorks new UI overview video (public/videos) in a dialog. The video unmounts on close, which stops playback.
export const OVERVIEW_VIDEO_SRC = '/videos/APWorks_New_UI_Overview.mp4';

export default function OverviewVideoDialog({ open, onClose }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="apw2-video-title">
            <DialogTitle id="apw2-video-title" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
                APWorks new UI overview
                <IconButton aria-label="Close" onClick={onClose} size="small"><CloseIcon fontSize="small" /></IconButton>
            </DialogTitle>
            <DialogContent>
                <video src={OVERVIEW_VIDEO_SRC} controls autoPlay playsInline preload="metadata" style={{ width: '100%', maxHeight: '70vh', background: '#000', borderRadius: 6 }}>
                    Your browser does not support video playback.
                </video>
            </DialogContent>
        </Dialog>
    );
}
